var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDining(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98438 5.14062C9.98438 4.03605 10.8798 3.14062 11.9844 3.14062C13.0889 3.14062 13.9844 4.03605 13.9844 5.14062V6.75838C18.5184 7.47758 21.9844 11.4043 21.9844 16.1406H1.98438C1.98438 11.4043 5.45038 7.47758 9.98438 6.75838V5.14062ZM10.9844 6.65357C11.15 6.64497 11.3167 6.64062 11.4844 6.64062H12.4844C12.6521 6.64062 12.8188 6.64497 12.9844 6.65357V5.14062C12.9844 4.58834 12.5367 4.14062 11.9844 4.14062C11.4321 4.14062 10.9844 4.58834 10.9844 5.14062V6.65357Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.48438 17.1406C1.20823 17.1406 0.984375 17.3645 0.984375 17.6406C0.984375 17.9168 1.20823 18.1406 1.48438 18.1406H22.4844C22.7605 18.1406 22.9844 17.9168 22.9844 17.6406C22.9844 17.3645 22.7605 17.1406 22.4844 17.1406H1.48438Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.98438 19.1406C2.70823 19.1406 2.48438 19.3645 2.48438 19.6406C2.48438 19.9168 2.70823 20.1406 2.98438 20.1406H20.9844C21.2605 20.1406 21.4844 19.9168 21.4844 19.6406C21.4844 19.3645 21.2605 19.1406 20.9844 19.1406H2.98438Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDining);
export default __webpack_public_path__ + "static/media/dining.71bedb733e5fa7838d23df5ea3dd7430.svg";
export { ForwardRef as ReactComponent };